import {useTranslation} from "react-i18next";
import DateDisplay from "components/datetime/DateDisplay";

const TableFleetRoutes = ({itemsShow, items, setItemsShow, buttonsTB, setButtonsTB, checkAll, setCheckAll}) => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useTranslation("choices");
    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            handleButtons();
        } else {
            setCheckAll(false);
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        const buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        setButtonsTB(buttons);
    };

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "130px", ...stickyHeaderStyle}}>
                        {_Tt("common.created")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={stickyHeaderStyle}>
                        {_Tt("containers.name")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "110px", ...stickyHeaderStyle}}>
                        {_Tt("users.driver")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "110px", ...stickyHeaderStyle}}>
                        {_Tt("fleet.truck")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "90px", ...stickyHeaderStyle}}>
                        {_Tt("fleet.session_status")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "140px", ...stickyHeaderStyle}}>
                        {_Tt("fleet.started_at")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "140px", ...stickyHeaderStyle}}>
                        {_Tt("fleet.completed_at")}
                    </th>
                    <th
                        className="sticky-top border-bottom-sticky"
                        style={{width: "70px", textAlign: "center", ...stickyHeaderStyle}}>
                        {_Tt("programming.stops")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "90px", ...stickyHeaderStyle}}>
                        {_Tt("fleet.kilos")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "90px", ...stickyHeaderStyle}}>
                        {_Tt("common.type")}
                    </th>
                </tr>
            </thead>
            <tbody>
                {itemsShow.map((item) => (
                    <tr key={item.id} data-idx={item.id} onClick={onClick}>
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td>
                            <DateDisplay date={item.created_at} format="DD/MM/YYYY HH:mm" />
                        </td>
                        <td>{item.name}</td>
                        <td>{item.driver_email || "-"}</td>
                        <td>{item.truck_plate || "-"}</td>
                        <td>{item.session_status ? _Tc(`session_status.${item.session_status}`) : "-"}</td>
                        <td>
                            {item.started_at ? <DateDisplay date={item.started_at} format="DD/MM/YYYY HH:mm" /> : "-"}
                        </td>
                        <td>
                            {item.completed_at ? <DateDisplay date={item.completed_at} format="DD/MM/YYYY HH:mm" /> : "-"}
                        </td>
                        <td className="text-center">{item.actives}</td>
                        <td>{item.kilos ? `${item.kilos} kg` : "-"}</td>
                        <td>{_Tc(`route_types.${item.type}`)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
export default TableFleetRoutes;
